import { useState, useEffect} from 'react';
import MieszkaniecStawki from './MieszkaniecStawki.js';
import MieszkaniecRozliczenieList from './MieszkaniecRozliczenieList.js';
import MieszkaniecWplaty from './MieszkaniecWplaty.js';
import MieszkaniecSaldo from './MieszkaniecSaldo.js';
import MieszkaniecWoda from './MieszkaniecWoda.js';
import { motion } from 'framer-motion';
import { wstepy } from '../../../functions/motions.js';
import { adresPro, findMieszkanieId } from '../../../functions/ulice.js';
import MieszkaniecDaneWodaRozliczenieWydrukModal from '../../Mieszkancy/Woda/Wydruk/MieszkaniecDaneWodaRozliczenieWydrukModal.js';

const MieszkaniecRozliczenie = props => {

    const { activeGroup, tablicaCzynsze, tablicaPrzelewy_g, stawkiOst, stawkiJednorazowe_w, mieszkaniec, udzialyKonta_a, lokale, ulice, 
        grupy_a, stawkiJednorazoweInd_u, rozliczenieWodyWmAktOpub, odczytyU } = props;

    const [open, setOpen] = useState(false);
    const [zestaw, setZestaw] = useState(false);

    const i = findMieszkanieId(udzialyKonta_a, grupy_a, lokale );
    const adres = adresPro(i, lokale, ulice);

    const [tablicaCzynszeAkt, setTablicaCzynszeAkt] = useState([]);
    const [wodaMsc, setWodaMsc] = useState(undefined);
    const [procent, setProcent] = useState(undefined);
    const [odczyty_g, setOdczyty_g] = useState(undefined);
    const [odczyt, setOdczyt] = useState(undefined);

    useEffect( () => {
        let len = tablicaCzynsze?.temp_msc?.length;
        if (len && len > 1)
            setTablicaCzynszeAkt( tablicaCzynsze?.temp_msc[len - 2] );
        else if (len && len === 1)
        setTablicaCzynszeAkt( tablicaCzynsze?.temp_msc[0] );
    },[tablicaCzynsze])

    useEffect( () => setWodaMsc(rozliczenieWodyWmAktOpub?.find( r => r?.miesiac == tablicaCzynszeAkt?.msc )), [rozliczenieWodyWmAktOpub, tablicaCzynszeAkt]);

    useEffect( () => setProcent( wodaMsc ? wodaMsc?.procenty?.find( p => p?.grupa_numer == udzialyKonta_a?.grupa_numer) : undefined ), [ udzialyKonta_a]); 

    useEffect( () => setOdczyty_g( odczytyU?.filter( o => o?.grupa_numer == udzialyKonta_a?.grupa_numer)), [odczytyU, udzialyKonta_a]);

    useEffect( () => {
        const temp = odczyty_g?.find( odczyt => new Date(odczyt?.okres_poczatek) >= new Date(zestaw?.okresPoczatek) 
            && new Date(odczyt?.okres_koniec) <= new Date(zestaw?.okresKoniec) )
        setOdczyt(temp);
    },[odczyty_g, zestaw])
    
    return (
        <motion.div 
            className="rozliczeniaContainer ramka-br ramka-border-shadow"
            variants={wstepy}
            initial="initial"
            animate="animate"
        >
            <h3>
                {`Rozliczenia miesięczne ${adres}`}
            </h3>
            <MieszkaniecStawki 
                stawkiOst={stawkiOst}
                tablicaCzynszeAkt={tablicaCzynszeAkt}
                mieszkaniec={mieszkaniec}
                udzialyKonta_a={udzialyKonta_a}
                lokale={lokale}
                ulice={ulice}
                grupy_a={grupy_a}
                stawkiJednorazoweInd_u={stawkiJednorazoweInd_u}
                wodaMsc={wodaMsc}
                procent={procent}
            />
            <MieszkaniecSaldo 
                tablicaCzynsze={tablicaCzynsze}
                tablicaPrzelewy_g={tablicaPrzelewy_g}
                procent={procent}
            />
            {
                rozliczenieWodyWmAktOpub && 
                <MieszkaniecWoda
                    rozliczenieWodyWmAktOpub={rozliczenieWodyWmAktOpub}
                    setOpen={setOpen}
                    setZestaw={setZestaw}
                />

            }

            <div className='tabele'>
                <MieszkaniecRozliczenieList 
                    activeGroup={activeGroup} 
                    tablicaCzynsze={tablicaCzynsze}
                    stawkiJednorazowe_w={stawkiJednorazowe_w}
                    stawkiJednorazoweInd_u={stawkiJednorazoweInd_u}
                    rozliczenieWodyWmAktOpub={rozliczenieWodyWmAktOpub}
                />  
                <MieszkaniecWplaty 
                    tablicaPrzelewy_g={tablicaPrzelewy_g}
                />
            </div>
            {
                open && (
                    <MieszkaniecDaneWodaRozliczenieWydrukModal
                        setShowPrint={setOpen}
                        rozliczenieWodyAkt={zestaw}
                        procent={zestaw?.procenty[0]}
                        odczyty={odczyt}
                        mieszkaniec={mieszkaniec}
                        adres={adres}
                    />
                )
            }
        </motion.div>
    )
}

export default MieszkaniecRozliczenie;